/** 问卷主表API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/st/stSurvey';
/**
 * 分页查询问卷主表
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.St.StSurvey> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询问卷主表列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.St.StSurvey> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个问卷主表
 *
 * @param id 问卷主表ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.St.StSurvey> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存问卷主表
 *
 * @param params 问卷主表信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新问卷主表信息
 *
 * @param params 问卷主表信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除问卷主表
 *
 * @param id 问卷主表ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除问卷主表
 *
 * @param ids 问卷主表ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export const getNotSharedSurvey: Api.CommonMethods.Save = params => {
  return post(`${prefix}/getNotSharedSurvey`, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  getNotSharedSurvey
};
